/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Deft_Ivory_Robin_NestInputs */

const en_deft_ivory_robin_nest = /** @type {(inputs: Deft_Ivory_Robin_NestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} custom`)
};

const de_deft_ivory_robin_nest = /** @type {(inputs: Deft_Ivory_Robin_NestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} benutzerdefiniert`)
};

/**
* | output |
* | --- |
* | "{count} custom" |
*
* @param {Deft_Ivory_Robin_NestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deft_ivory_robin_nest = /** @type {((inputs: Deft_Ivory_Robin_NestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deft_Ivory_Robin_NestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deft_ivory_robin_nest(inputs)
	return de_deft_ivory_robin_nest(inputs)
});